import { stardust } from '@eidellev/adonis-stardust/client';

/**
 * Check if a form is valid
 * @param $ jQuery
 * @param form Form element
 * @param honey Honeypot value
 */
export const checkValid = ($: any, form: HTMLFormElement, honey: string) => {
  return new Promise((resolve, reject) => {
    if ($(form).parsley().isValid() && !(honey.length)) {
      resolve('success');
    } else {
      reject(new Error('not valid'));
    }
  });
};

/**
 * Throttle a function
 * @param callback Callback function
 * @param limit How often to call the callback
 */
export function _throttle(callback: Function, limit: number) {
  let waiting = false; // Initially, we're not waiting
  return function() { // We return a throttled function
    if (!waiting) { // If we're not waiting
      callback.apply(this, arguments); // Execute users function
      waiting = true; // Prevent future invocations
      setTimeout(function() { // After a period of time
        waiting = false; // And allow future invocations
      }, limit);
    }
  };
}

/**
 * Preload images
 * @param images Array of image paths
 */
export function preloadImages(images: string[]) {
  images.forEach((image) => {
    new Image().src = image;
  });
}

/**
 * Make an API call to the backend to delete a file
 * @param handle handle of the file to delete
 * @returns The JSON response from the backend
 */
export async function deleteMediaFromBackend(handle: string) {
  const submitUrl = stardust.route('api.filestack.delete', { handle });
  const csrf = document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement;
  const response = await fetch(submitUrl, {
    method: 'DELETE',
    headers: { 'X-CSRF-TOKEN': csrf.content },
  });

  try {
    if (!response.ok) {
      throw new Error(`Failed to delete resource ${handle}`);
    }

    return response.json();
  } catch (e) {
    console.error(e);
    return null;
  }
};
